module.exports = __webpack_public_path__ + "img/dynamic-1.43732753.png";